import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/usr/src/app/layouts/default.vue").then(m => m.default || m)),
  "without-bars": defineAsyncComponent(() => import("/usr/src/app/layouts/without-bars.vue").then(m => m.default || m)),
  "without-sidebar": defineAsyncComponent(() => import("/usr/src/app/layouts/without-sidebar.vue").then(m => m.default || m))
}